export const POPULAR_MAKES = {
  ACURA: {
    name: "Acura",
  },
  AUDI: {
    name: "Audi",
  },
  BMW: {
    name: "BMW",
  },
  BUICK: {
    name: "Buick",
  },
  CAD: {
    name: "Cadillac",
  },
  CHEV: {
    name: "Chevrolet",
  },
  CHRY: {
    name: "Chrysler",
  },
  DODGE: {
    name: "Dodge",
  },
  FER: {
    name: "Ferrari",
  },
  FORD: {
    name: "Ford",
  },
  GENESIS: {
    name: "Genesis",
  },
  GMC: {
    name: "GMC",
  },
  HONDA: {
    name: "Honda",
  },
  HYUND: {
    name: "Hyundai",
  },
  INFIN: {
    name: "INFINITI",
  },
  JAG: {
    name: "Jaguar",
  },
  JEEP: {
    name: "Jeep",
  },
  KIA: {
    name: "Kia",
  },
  ROV: {
    name: "Land Rover",
  },
  LEXUS: {
    name: "Lexus",
  },
  LINC: {
    name: "Lincoln",
  },
  MAZDA: {
    name: "MAZDA",
  },
  MB: {
    name: "Mercedes-Benz",
  },
  MINI: {
    name: "MINI",
  },
  MIT: {
    name: "Mitsubishi",
  },
  NISSAN: {
    name: "Nissan",
  },
  POLESTAR: {
    name: "Polestar",
  },
  POR: {
    name: "Porsche",
  },
  RAM: {
    name: "RAM",
  },
  SUB: {
    name: "Subaru",
  },
  TESLA: {
    name: "Tesla",
  },
  TOYOTA: {
    name: "Toyota",
  },
  VOLKS: {
    name: "Volkswagen",
  },
  VOLVO: {
    name: "Volvo",
  },
};


